import React from 'react';
import styles from './APLoader.module.css';

export const APLoader: React.FC = () => {
  return <div className={styles.spinner}></div>;
};
